import actions from '../../actionTypes';

export default filter => {
  return {
    type: actions.REMOVE_FILTER,
    filter
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/removeFilter.js